import React, { useCallback } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
// import cx from 'classnames';
import s from './Sidebar.module.scss';

import useLogout from '../../use/useLogout';
import { INavItem, LS_AUTH_TOKEN, ROUTE } from '../../config/constants';
import { IUser } from '../../reducers/user.model';
import { getRandomInt } from '../../global';

import { ReactComponent as IconLogo } from '../../icons/logo/logo.svg';
import { ReactComponent as IconMonitoring } from '../../icons/sidebar/monitoring.svg';
import { ReactComponent as IconMonitoringActive } from '../../icons/sidebar/monitoring-active.svg';
import { ReactComponent as IconSite } from '../../icons/sidebar/site.svg';
import { ReactComponent as IconSiteActive } from '../../icons/sidebar/site-active.svg';
import { ReactComponent as IconOkkoPay } from '../../icons/sidebar/okko-pay.svg';
import { ReactComponent as IconOkkoPayActive } from '../../icons/sidebar/okko-pay-active.svg';
import { ReactComponent as IconStore } from '../../icons/sidebar/store.svg';
import { ReactComponent as IconStoreActive } from '../../icons/sidebar/store-active.svg';
import { ReactComponent as IconOrder } from '../../icons/sidebar/order.svg';
import { ReactComponent as IconOrderActive } from '../../icons/sidebar/order-active.svg';

import { ReactComponent as IconAvatar1 } from '../../icons/avatar/avatar1.svg';
import { ReactComponent as IconAvatar2 } from '../../icons/avatar/avatar2.svg';
import { ReactComponent as IconAvatar3 } from '../../icons/avatar/avatar3.svg';
import { ReactComponent as IconAvatar4 } from '../../icons/avatar/avatar4.svg';

let navId = 1;
export const NAV_LINK: INavItem[] = [
    {
        id: navId++,
        label: 'Моніторинг',
        icon: <IconMonitoring />,
        iconActive: <IconMonitoringActive className="iconActive" />,
        link: '/',
        exact: true,
    },
    {
        id: navId++,
        label: 'Торгові точки',
        icon: <IconSite />,
        iconActive: <IconSiteActive className="iconActive" />,
        link: ROUTE.SITE,
    },
    {
        id: navId++,
        label: 'OKKO PAY',
        icon: <IconOkkoPay />,
        iconActive: <IconOkkoPayActive className="iconActive" />,
        link: ROUTE.OKKO_PAY,
    },
    {
        id: navId++,
        label: 'Магазини',
        icon: <IconStore />,
        iconActive: <IconStoreActive className="iconActive" />,
        link: ROUTE.STORE,
    },
    {
        id: navId++,
        label: 'Замовлення',
        icon: <IconOrder />,
        iconActive: <IconOrderActive className="iconActive" />,
        link: ROUTE.ORDER,
    },
    {
        id: navId++,
        label: 'Каталог Bolt',
        icon: <IconStore />,
        iconActive: <IconStoreActive className="iconActive" />,
        link: ROUTE.BOLT_PIM,
    },
];

const getRandomAvatar = (index: number): React.ReactNode => {
    switch (index) {
        case 2:
            return <IconAvatar2 />;
        case 3:
            return <IconAvatar3 />;
        case 4:
            return <IconAvatar4 />;
        default:
            return <IconAvatar1 />;
    }
};

const parseJwt = (token: string): any => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
    );

    return JSON.parse(jsonPayload);
};

interface IProps {
    permission?: any;
    user: IUser;
    onLogout: () => void;
}

export const Sidebar: React.FC<IProps> = (props) => {
    const history = useHistory();
    const jwt = parseJwt(sessionStorage.getItem(LS_AUTH_TOKEN) || '');
    const avatar = getRandomAvatar(getRandomInt(1, 4));

    const [onShowLogout, Logout] = useLogout({
        userName: jwt.login || '',
        onLogout: async () => {
            await props.onLogout();
            history.push(ROUTE.LOGIN);
        },
    });

    const createLink = useCallback(
        (item: INavItem): any => (
            <NavLink
                to={item.link || '/'}
                className={s.navLink}
                activeClassName="active"
                exact={item.exact}
                target={item.target}
            >
                {item.icon ? (
                    <i className={s.navIcon}>
                        {item.icon}
                        {item.iconActive}
                    </i>
                ) : (
                    <i className={s.navSymbol}>{item.symbol || item.label?.charAt(0)}</i>
                )}
                <span>{item.label}</span>
            </NavLink>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <>
            <div className={s.container}>
                <NavLink to="/" className={s.logo}>
                    <IconLogo className={s.iconLogo} />
                </NavLink>

                <ul className={s.navList}>
                    {NAV_LINK.map((item: INavItem) => (
                        <li key={item.id}>{createLink(item)}</li>
                    ))}
                </ul>

                <div className={s.user} onClick={onShowLogout}>
                    <div className={s.userLogo}>{avatar}</div>
                </div>
            </div>

            {Logout}
        </>
    );
};

export default Sidebar;
